import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.css'],
})
export class ConfirmDialogComponent {
  icon: string;
  title: string;
  message: string;

  variant: DialogVariant;

  dialogVariant = DialogVariant;

  dialogType = DialogType;
  type: DialogType;
  confirmColor: ButtonColors = ButtonColors.primary;
  cancelColor: ButtonColors = ButtonColors.accent;
  yesText: string = 'Yes';
  noText: string = 'No';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel
  ) {
    this.title = data.title;
    this.message = data.message;
    this.variant = data.variant;
    this.type = data.dialogType;
    this.confirmColor = data.confirmColor;
    this.cancelColor = data.cancelColor;
    this.yesText = data.yesText;
    this.noText = data.noText;
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onDismiss(): void {
    this.dialogRef.close(false);
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */

export enum DialogType {
  None,
  Success,
  Warning,
  Error,
  Info,
}

export enum DialogVariant {
  YesNo,
  OK,
}
export enum ButtonColors {
  accent = '',
  primary = 'primary',
}
export class ConfirmDialogModel {
  constructor(
    public title: string,
    public message: string,
    public variant: DialogVariant = DialogVariant.YesNo,
    public dialogType: DialogType = DialogType.None,
    public confirmColor: ButtonColors = ButtonColors.primary,
    public cancelColor: ButtonColors = ButtonColors.accent,
    public yesText: string = 'Yes',
    public noText: string = 'No',
    public billType: string = '',
    public innerHtml: string = ''
  ) {}
}
